import React from "react";
import styled from "styled-components";

const Container = styled.div`
    position: relative;
    flex: 1 0 100vw;
    background: ${(props) => props.background};
    color: ${(props) => props.fontColor};
    height: 100%;

    .wrap {
        max-width: 800px;
        margin: 0 auto;
    }

    .step-header,
    .step-body,
    .step-footer {
        padding: 30px 30px;
    }

    .step-header-booking {
        background-color: #000;
        width: 100%;
        height: 80px;
        display: inline-grid;
        border-radius: 0px 0px 30px 0px;
    }

    @media (min-width: 374px) and (max-width: 799px) {
        &:first-child .step-footer {
            position: relative;
        }

        .step-footer {
            width: 100%;
            position: absolute;
            left: 0;
            bottom: 0;
        }
    }

    .step-header p {
        font-size: 30px;
        font-weight: bold;
        text-align: center;
        margin-bottom: 15px;
    }

    .step-header span {
        display: block;
        color: #5b5b5b;
        font-size: 14px;
        text-align: center;
    }

    .step-body .categories {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
    }

    .step-body .categories .category {
        color: #1b1b1b;
        fill: #1b1b1b;
        border: 1px solid white;
        background-color: white;
        border-radius: 4px;
        width: 128px;
        height: 80px;
        text-align: center;
        transition: all 0.2s linear;
        cursor: pointer;
        flex-basis: 128px;
        margin: 10px auto;
    }

    .step-body .categories .category:hover,
    .step-body .categories .category.active {
        border-color: orange;
        color: orange;
        fill: orange;
    }

    .step-body .categories .category svg {
        margin-top: 10px;
        width: 35px;
        height: 35px;
    }

    .step-body .categories .category p {
        padding-left: 10px;
        line-height: 30px;
        font-size: 10px;
        font-weight: bold;
        letter-spacing: 1.5px;
        text-transform: uppercase;
    }

    .step-body .subcategories {
        flex: 0 1 680px;
        display: flex;
        flex-wrap: wrap;
        background-color: white;
        border-radius: 4px;
        padding: 15px 25px;
        margin: 0 auto;
    }

    .step-body .subcategories div {
        cursor: pointer;
        flex: 0 0 125px;
        text-align: center;
        color: #5b5b5b;
        line-height: 310%;
        font-size: 12px;
    }

    .step-body .subcategories div.active {
        color: orange;
    }

    .step-body .multiple-jobs {
        display: flex;
        justify-content: space-between;
    }

    .step-body .multiple-jobs button {
        background-color: white;
        border-radius: 30px;
        padding: 15px 0px;
        width: 45%;
        color: #989898;
        text-transform: uppercase;
    }

    .step-body .multiple-jobs button.selected {
        border: 0.5px solid #5064ee;
        color: #5064ee;
    }

    .step-body .booking-job .hours-book button {
        background-color: transparent;
    }

    .step-body .booking-job .hours-book {
        display: flex;
        align-items: flex-start;
    }

    .step-body .booking-job .hours-book .list-items {
        overflow: auto;
    }

    .step-body .booking-job .hours-book ul {
        display: flex;
        color: #989898;
    }

    .step-body .booking-job .hours-book ul li {
        cursor: pointer;
        padding-right: 20px;
    }

    .step-body .booking-job .hours-book ul li a {
        text-decoration: none;
        cursor: pointer;
        font-weight: 100;
        color: #989898;
    }

    .step-body .booking-job .hours-book ul li a:hover {
        text-decoration: none;
        font-weight: bold;
        color: #5064ee;
    }

    .step-body .booking-job .hours-book ul li a:active {
        text-decoration: none;
        font-weight: bold;
        color: #5064ee;
    }

    .step-body .booking-job .hours-book ul li a[tabindex]:focus {
        text-decoration: none;
        font-weight: bold;
        color: #5064ee;
    }

    .step-body .personal-data-extra span {
        color: #5b5b5b;
        font-size: 12px;
        vertical-align: text-top;
        padding-left: 10px;
    }

    .step-body .personal-data-extra input.code-customer-empty {
        width: 5% !important;
        height: 20px;
        margin-left: 30px;
        margin-top: 5px;
    }

    .step-body label {
        display: inline-block;
        padding: 5px 25px;
        font-size: 12px;
    }

    .step-body input {
        height: 50px;
        border-radius: 25px;
        padding: 0px 20px;
        width: 100%;
    }

    .step-body input::placeholder {
        color: #9d9d9d;
    }

    .step-body input.text-error::placeholder {
        color: #e43638;
    }

    .step-body input.text-error {
        border: 0.5px solid #e43638;
    }

    .step-body input:focus {
        border: 0.5px solid #5064ee;
    }

    .step-body .location div {
        margin-bottom: 15px;
    }

    .step-body .location .input-group {
        position: relative;
    }

    .step-body .location .input-group svg {
        position: absolute;
        top: 14px;
        left: 20px;
        width: 24px;
        height: 24px;
    }

    .step-body .location .input-group input {
        padding: 0px 20px 0px 60px;
    }

    .step-body #date {
        border-radius: 25px !important;
        width: 100%;
    }

    .step-body .timepicker {
        background-color: #eee;
        white-space: nowrap;
        border-radius: 25px;
    }

    .step-body .timepicker select {
        width: 50%;
        border-radius: 0px 25px 25px 0px;
        box-shadow: unset;
    }

    .step-body .timepicker select:first-child {
        border-radius: 25px 0px 0px 25px;
        border-right: 1px solid #eee;
    }

    .step-body .timepicker select:last-child {
        background-position: top 20px right 20px;
    }

    .step-body .price .options {
        width: 100%;
        position: absolute;
        bottom: 20px;
        left: 0px;
        display: flex;
        justify-content: space-between;
        padding: 0px 18px;
    }

    .step-body .price .options button {
        background: transparent;
        font-size: 12px;
        border-radius: 30px;
        border: 0.5px solid #989898;
        padding: 10px 16px;
        color: #989898;
    }

    .step-body .price::before {
        content: "Digite o valor desejado";
        color: #bcbcbc;
        font-size: 12px;
        position: absolute;
        top: 20px;
        left: 18px;
    }

    .step-body .price {
        position: relative;
        border-radius: 16px;
        background-color: white;
        font-size: 50px;
        width: 100%;
        height: 200px;
    }

    .step-body .price input {
        border: 0.5px solid transparent;
        background: transparent;
        text-align: center;
        position: relative;
        font-size: 36px;
        width: 100%;
        height: 100%;
        padding: 20px 18px 40px 18px;
        color: #bcbcbc;
    }

    .step-body .price input:focus {
        border: 0.5px solid #5064ee;
        color: #5064ee;
    }

    .step-body .btn-price-suggestion {
        cursor: pointer;
        margin-top: 10px;
        margin-bottom: 20px;
        padding-left: 20px;
        color: #5b5b5b;
        font-size: 12px;
    }

    .step-body .btn-price-suggestion div {
        display: inline-block;
        background-color: white;
        border: 0.5px solid #5064ee;
        border-radius: 50%;
        box-shadow: 0px 3px 6px #e8e8e8;
        padding: 4px 7px;
        margin-left: 5px;
    }

    .step-body .price-suggestions {
        background-color: white;
        border: 0.5px solid #5064ee;
        border-radius: 16px;
        width: 100%;
        padding: 30px 25px;
    }

    .step-body .price-suggestions .title {
        font-size: 20px;
        margin-bottom: 40px;
    }

    .step-body .price-suggestions .subtitle {
        color: #bcbcbc;
        font-size: 12px;
    }

    .step-body .price-suggestions .category {
        color: #5064ee;
        font-size: 14px;
        margin-bottom: 20px;
    }

    .step-body .price-suggestions .experience-levels {
        margin-top: 15px;
    }

    .step-body .price-suggestions .experience-levels .value::before {
        content: attr(prefix);
        font-size: 8px;
    }

    .step-body .price-suggestions .experience-levels .level {
        display: flex;
        justify-content: space-between;
        margin-bottom: 15px;
    }

    .step-body .price-suggestions .experience-levels .name {
        font-size: 14px;
        color: #5b5b5b;
    }

    .step-body .price-suggestions .experience-levels .value {
        font-size: 14px;
        color: #5064ee;
    }

    .step-body .price-suggestions button {
        background: transparent;
        font-weight: normal;
        float: right;
        color: #5064ee;
    }

    .step-body textarea {
        width: 100%;
        border-radius: 16px;
        text-align: left !important;
        padding: 25px;
    }

    .step-body .business-briefing textarea {
        width: 100%;
        border-radius: 16px;
        text-align: left !important;
        padding: 25px;
        margin-top: 50px;
    }

    .step-body .notice textarea {
        width: 100%;
        border-radius: 16px;
        text-align: left !important;
        padding: 25px;
    }

    .step-body .price input::placeholder,
    .step-body .price input::-webkit-input-placeholder {
        font-family: "Oswald", sans-serif;
        font-size: 100px;
        color: black;
        opacity: 1;
    }

    .step-body .personal-data div {
        margin-bottom: 15px;
    }

    .step-body .success {
        text-align: center;
        width: 100%;
        border-radius: 8px;
        box-shadow: 0px 10px 20px 0px rgba(0, 0, 0, 0.2);
        overflow: hidden;
    }

    .step-body .success .ok {
        height: 200px;
    }

    .step-body .success .ok div {
        position: relative;
        width: 90px;
        height: 90px;
        border-radius: 50%;
        border: 3px solid #21b970;
        top: 50%;
        margin: 0 auto;
        transform: translateY(-50%);
        background-image: url("../icons/icones_fotografoja-07.svg");
        background-size: 30px 30px;
        background-repeat: no-repeat;
        background-position: center center;
    }

    .step-body .success .text {
        background-color: #21b970;
        color: white;
        padding: 15px 0px;
        font-weight: bold;
    }

    .btn.arrow.btn-outlined::after {
        background-image: url("../icons/icones_fotografoja-13.svg");
    }

    @media (min-width: 820px) {
        .step-body .booking-job .hours-book .list-items {
            overflow: hidden;
        }
    }

    @media (min-width: 1000px) {
        .step-body {
            min-height: 70px;
        }
    }
`;

const FormStep = (props) => {
    return (
        <Container background={props.background} fontColor={props.fontColor}>
            <div className="wrap">{props.children}</div>
        </Container>
    );
};

export default FormStep;
